var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 124,
    viewBox: "0 0 143 124",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_103250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3001 106.259C98.3001 106.259 121 83.5592 121 55.4592C121 27.3592 98.2001 4.65918 70.3001 4.65918C42.3001 4.65918 19.6001 27.3592 19.6001 55.4592C19.6001 83.5592 42.3001 106.259 70.3001 106.259Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7 6.15957C125.246 6.15957 126.5 4.90596 126.5 3.35957C126.5 1.81317 125.246 0.55957 123.7 0.55957C122.154 0.55957 120.9 1.81317 120.9 3.35957C120.9 4.90596 122.154 6.15957 123.7 6.15957Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 22.059C23.8464 22.059 25.1 20.8053 25.1 19.259C25.1 17.7126 23.8464 16.459 22.3 16.459C20.7536 16.459 19.5 17.7126 19.5 19.259C19.5 20.8053 20.7536 22.059 22.3 22.059Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 76.0592C8.07188 76.0592 10.4 73.7311 10.4 70.8592C10.4 67.9873 8.07188 65.6592 5.2 65.6592C2.32812 65.6592 0 67.9873 0 70.8592C0 73.7311 2.32812 76.0592 5.2 76.0592Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7526_103250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.611 28.7762V87.6139C118.611 89.3401 117.173 90.7787 115.446 90.7787H26.0389C24.3126 90.8507 22.874 89.4121 22.874 87.6858V28.7762C22.874 26.978 24.3126 25.6113 26.0389 25.6113H115.446C117.244 25.6113 118.611 27.0499 118.611 28.7762Z",
    fill: "url(#paint0_linear_7526_103250)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.611 28.7762V33.3077H22.874V28.7762C22.874 26.978 24.3126 25.6113 26.0389 25.6113H115.446C117.244 25.6113 118.611 27.0499 118.611 28.7762Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5437 56.1088C59.0135 56.1088 60.205 54.9172 60.205 53.4474C60.205 51.9776 59.0135 50.7861 57.5437 50.7861C56.0739 50.7861 54.8823 51.9776 54.8823 53.4474C54.8823 54.9172 56.0739 56.1088 57.5437 56.1088Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0134 56.1088C85.4832 56.1088 86.6748 54.9172 86.6748 53.4474C86.6748 51.9776 85.4832 50.7861 84.0134 50.7861C82.5436 50.7861 81.3521 51.9776 81.3521 53.4474C81.3521 54.9172 82.5436 56.1088 84.0134 56.1088Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0943 73.5871H66.7506C65.4559 73.5871 64.377 72.5082 64.377 71.2135C64.377 69.9188 65.4559 68.8398 66.7506 68.8398H75.0224C76.3171 68.8398 77.396 69.9188 77.396 71.2135C77.468 72.5082 76.389 73.5871 75.0943 73.5871Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.118 30.7897C27.7139 30.7897 28.1969 30.3066 28.1969 29.7107C28.1969 29.1149 27.7139 28.6318 27.118 28.6318C26.5221 28.6318 26.0391 29.1149 26.0391 29.7107C26.0391 30.3066 26.5221 30.7897 27.118 30.7897Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4984 30.7897C31.0942 30.7897 31.5773 30.3066 31.5773 29.7107C31.5773 29.1149 31.0942 28.6318 30.4984 28.6318C29.9025 28.6318 29.4194 29.1149 29.4194 29.7107C29.4194 30.3066 29.9025 30.7897 30.4984 30.7897Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.951 30.7897C34.5469 30.7897 35.0299 30.3066 35.0299 29.7107C35.0299 29.1149 34.5469 28.6318 33.951 28.6318C33.3551 28.6318 32.8721 29.1149 32.8721 29.7107C32.8721 30.3066 33.3551 30.7897 33.951 30.7897Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.727 17.9866C114.008 17.9866 113.432 17.4112 113.432 16.6919V2.23417C113.432 1.51489 114.008 0.939453 114.727 0.939453C115.446 0.939453 116.022 1.51489 116.022 2.23417V16.6919C116.022 17.4112 115.446 17.9866 114.727 17.9866Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.229 29.0634C125.229 28.3441 125.804 27.7686 126.523 27.7686H140.981C141.7 27.7686 142.276 28.3441 142.276 29.0634C142.276 29.7826 141.7 30.3581 140.981 30.3581H126.523C125.804 30.3581 125.229 29.7826 125.229 29.0634Z",
    fill: "#989FB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.078 19.7136C123.574 19.2101 123.574 18.347 124.078 17.8435L134.364 7.62958C134.867 7.12608 135.73 7.12608 136.234 7.62958C136.737 8.13308 136.737 8.99623 136.234 9.49973L126.02 19.7136C125.444 20.2171 124.581 20.2171 124.078 19.7136Z",
    fill: "#989FB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7526_103250",
    x: 0.874023,
    y: 14.6113,
    width: 139.737,
    height: 109.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7526_103250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7526_103250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7526_103250",
    x1: 70.7114,
    y1: 24.1039,
    x2: 70.7114,
    y2: 91.4839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#5C6479"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_103250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.3b2f72eba831e5522846ca265c94e44e.svg";
export { ForwardRef as ReactComponent };